import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { RecognitionEventArgs } from "./Exports";
/**
 * Defines content of a RecognitionErrorEvent.
 * @class SpeechRecognitionCanceledEventArgs
 */

export var SpeechRecognitionCanceledEventArgs = /*#__PURE__*/function (_RecognitionEventArgs) {
  _inherits(SpeechRecognitionCanceledEventArgs, _RecognitionEventArgs);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */
  function SpeechRecognitionCanceledEventArgs(reason, errorDetails, errorCode, offset, sessionId) {
    var _this;

    _classCallCheck(this, SpeechRecognitionCanceledEventArgs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpeechRecognitionCanceledEventArgs).call(this, offset, sessionId));
    _this.privReason = reason;
    _this.privErrorDetails = errorDetails;
    _this.privErrorCode = errorCode;
    return _this;
  }
  /**
   * The reason the recognition was canceled.
   * @member SpeechRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */


  _createClass(SpeechRecognitionCanceledEventArgs, [{
    key: "reason",
    get: function get() {
      return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */

  }, {
    key: "errorCode",
    get: function get() {
      return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member SpeechRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */

  }, {
    key: "errorDetails",
    get: function get() {
      return this.privErrorDetails;
    }
  }]);

  return SpeechRecognitionCanceledEventArgs;
}(RecognitionEventArgs);